import { Link } from "react-router-dom";
import { Aperture, BookOpen, Compass, Images, LibraryBig, Podcast, Rss, Send } from "lucide-react";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useUsername } from "@/hooks/useUsername";
import { AppSeo } from "@/components/AppSeo";

const tiles = [
  {
    to: "/my-library",
    label: "My Library",
    description: "Your sources of truth — books, articles, and more.",
    icon: LibraryBig,
  },
  {
    to: "/excerpts",
    label: "My Excerpts",
    description: "Capture and curate the passages you want to keep.",
    icon: BookOpen,
  },
  {
    to: "/composer",
    label: "Composer",
    description: "Draft long-form pieces from your own corpus.",
    icon: Compass,
  },
  {
    to: "/publisher",
    label: "Publisher",
    description: "Select and ship pieces to your destinations.",
    icon: Send,
  },
  {
    to: "/feed-reader",
    label: "My Feed Reader",
    description: "Your RSS inbox — triage and save to Library.",
    icon: Rss,
  },
  {
    to: "/podcasts",
    label: "My Podcasts",
    description: "Discover, transcribe, and excerpt episodes.",
    icon: Podcast,
  },
  {
    to: "/image-studio",
    label: "Image Studio",
    description: "Generate excerpt images and other visual assets.",
    icon: Aperture,
  },
  {
    to: "/workspace-media",
    label: "Workspace Media",
    description: "Manage uploads and generated media for this workspace.",
    icon: Images,
  },
];

const Dashboard = () => {
  const { username } = useUsername();

  return (
    <>
    <AppSeo title="Dashboard" />
    <div className="mx-auto w-full max-w-5xl px-4 py-8 sm:px-6 lg:px-8 space-y-8">
      <header className="space-y-2">
        <h1 className="font-serif text-3xl sm:text-4xl font-semibold text-primary">
          Welcome back{username ? `, @${username}` : ""}
        </h1>
        <p className="text-muted-foreground">
          Research. Write. Publish — from one source of truth.
        </p>
      </header>

      <section className="grid gap-4 sm:grid-cols-2">
        {tiles.map(({ to, label, description, icon: Icon }) => (
          <Link key={to} to={to} className="group">
            <Card className="h-full transition-shadow group-hover:shadow-elevated">
              <CardHeader className="flex flex-row items-start gap-3 space-y-0">
                <div className="rounded-md bg-primary/10 p-2 text-primary">
                  <Icon className="h-5 w-5" />
                </div>
                <div className="space-y-1">
                  <CardTitle className="text-lg">{label}</CardTitle>
                  <CardDescription>{description}</CardDescription>
                </div>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </section>
    </div>
    </>
  );
};

export default Dashboard;
